import React, { useEffect } from "react";
import { useReveal } from "../hooks/useReveal";
import Hero from "../components/home/Hero";
import About from "../components/home/About";
import Services from "../components/home/Services";
import Gallery from "../components/home/Gallery";
import Availability from "../components/home/Availability";
import Process from "../components/home/Process";
import CTA from "../components/home/CTA";

export default function Home() {
  const ref = useReveal();

  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, []);

  return (
    <main ref={ref}>
      <Hero />
      <Services />
      <Gallery />
      <Process />
      <Availability />
      <CTA />
      <About />
    </main>
  );
}
